export default function(to, from, next) {
    const seoTitle = to.meta
        ? to.meta.title || 'Zgody - Makro Cash & Carry Polska'
        : 'Zgody - Makro Cash & Carry Polska'
    const templateType = to.meta ? to.meta.templateType || 'article' : 'article'

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
        GA360_solution: 'mcd',
        GA360_country: 'PL',
        GA360_pageName: `${seoTitle} | PL | ${templateType}`,
        GA360_pageTitle: `${seoTitle} | ${templateType}`,
        GA360_templateType: `${templateType}`,
        GA360_userInterface: 'responsive-site',
        GA360_errorPage: 'no-errorpage',
        GA360_statusCode: 200
    })

    window.dataLayer.push({
        event: 'page.impression',
        pageType: 'PageView',
        pageUrl: to.fullPath,
        routeName: 'all'
    })

    return next()
}
